export class StateHandler {

    protected _currentState: any;
    protected _lastState: any;

    protected _bindedFunc: Map<any, Function>;

    public get value(): any { return this._currentState; }
    public get lastState(): any { return this._lastState; }

    constructor(state?: any, bindo?: Map<any, Function >) {
        this._lastState = this._currentState = state;
        bindo && (this._bindedFunc = bindo)
    }

    triggerState(skip?:Function) {
        if (this._bindedFunc) {
            this._bindedFunc.get(this._currentState)!(skip);
        }
    }

    equal(value: any): boolean {
        return this.value === value;
    }

    set(value: any): void {
        this._lastState = this._currentState;
        this._currentState = value;
    }
}

